import React from "react";
import { motion } from "framer-motion";
import { Trophy, Star, Award, Medal } from "lucide-react";
import awards from "../../../data/awards";

// data/awards.js stays plain data; each consumer maps the key to its own icon size
const ICONS = {
  trophy: <Trophy size={18} />,
  medal: <Medal size={18} />,
  star: <Star size={18} />,
  award: <Award size={18} />,
};

function AboutArea() {

  return (
    <section className="about-centered section-light sec-pad">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="sec-title text-center wow animate fadeInUp">
              <span>How We Operate</span>
              <h2>One Team. A Portfolio of AI Products.</h2>
            </div>

            <div className="about-subtitle text-center wow animate fadeInUp" data-wow-delay="200ms">
              DLPlatforms Pty Ltd is an Australian company building and
              operating AI products end to end, with research, engineering,
              design and growth under one roof. Shared infrastructure and a
              single product team let us take a new idea from prototype to
              paying users without rebuilding the foundations every time.
            </div>

            <div className="award-grid-centered">
              {awards.map((award, index) => (
                <motion.div
                  key={award.id}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4 }}
                  className="award-box-mini"
                >
                  <div className="award-icon-v2">{ICONS[award.icon]}</div>
                  <span style={{ fontWeight: 600, fontSize: "14px" }}>
                    {award.short}
                  </span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        <div className="centered-collage-wrapper wow animate fadeInUp" style={{ marginTop: '100px' }}>
          <div className="collage-item item-side-1">
            <img
              src={process.env.PUBLIC_URL + "/img/dl2.jpg"}
              alt="The DLPlatforms product team at work"
            />
          </div>

          <div className="collage-item item-side-2">
            <img src={process.env.PUBLIC_URL + "/img/dl3.jpg "} alt="The DLPlatforms team" />
          </div>

          <div className="collage-item item-main">
            <img
              src={process.env.PUBLIC_URL + "/img/dl1.jpg"}
              alt="Inside the DLPlatforms office"
            />
            <div className="image-mask" style={{ height: "40%" }}></div>
          </div>

          {/* Background Accent */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "130%",
              height: "100%",
              background:
                "radial-gradient(circle, rgba(117, 218, 180, 0.08) 0%, transparent 70%)",
              transform: "translate(-50%, -50%)",
              zIndex: -1,
            }}
          ></div>
        </div>
      </div>
    </section>
  );
}

export default AboutArea;
